/* =========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
========================================================================================== */
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// Global
import state from './global/state'
import getters from './global/getters'
import mutations from './global/mutations'
import actions from './global/actions'

import context from './modules/context/index'
import { MSConstant } from '@/commons/wildcards'
// Modules
const vuexModules = require.context(
  './modules',
  false,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)

function mapModules (context) {
  const _modules = {}
  const keys = context.keys()
  const values = keys.map(context)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched?.length > 1) {
      const moduleName = matched[1]
      const module = values[i].default

      if (module) {
        _modules[moduleName] = module
      }
    }
  }
  return _modules
}

const modules = mapModules(vuexModules)

// Init instance of store
export default createStore({
  getters,
  mutations,
  state,
  actions,
  modules: {
    ...modules,
    context,
  },
  strict: false,
  plugins: [
    createPersistedState({
      key: MSConstant.Storage.Local.Context,
      paths: ['context'],
      getState: key => {
        const temp = localStorage.getItem(key) || '{}'
        const token = localStorage.getItem(MSConstant.Storage.Local.Token)

        if (temp && typeof temp === 'string') {
          let state = JSON.parse(temp)
          if (token) {
            state ??= {}
            state.context ??= {}
          }

          if (state) {
            const context = state.context
            if (context) {
              context.Token = token
              context.Context = context.Context || {}

              try {
                context.TokenExpired = context.TokenExpired && new Date(context.TokenExpired)
              } catch (ex) {
                console.error(ex)
              }
            }
          }

          return state
        }
        return null
      },
      setState: (key, state) => {
        localStorage.setItem(key, JSON.stringify(state))
      },
    }),
  ],
})
